import {
    CreateCommentTeaserContainer,
    CreateCommentTeaserTextBox,
    PostCardContentDivider,
    PostPreviewSectionFooterText,
} from "./Post.styles";
import CommentPreview from "../Comment/CommentPreview";
import React from "react";
import { PostType } from "./Post.types";
import { CommentType } from "../Comment/CommentTypes";
import { useUserProfile } from "@infrastructure/Persistence/UserProfileState";
import { AvatarOptions } from "../UserAvatar/UserAvatar.types";
import userAvatarChecker from "../../Shared/UserAvatarChecker";
import { UserAvatarFactory } from "../UserAvatar/UserAvatarFactory";
import { CommentAvatar } from "../Comment/Comment.styles";
import { FunFactsSection } from "../GameTimelinePost/FunFacts/FunFactsSection";
import { useFunFactsStore } from "../GameTimelinePost/FunFacts/GamesFinFactsStore";

export function PostCommentPreviewSection({
    post,
    handleCommentPreviewOptionsClicked,
    handleCommentPreviewReportClicked,
    createReactOnPreviewComment,
    openCommentPreviewOwnerAvatarModal,
    onCommentButtonClick,
    onCommentPreviewClick,
    showCommentTeaser = true,
}: {
    onCommentButtonClick: (
        e: React.MouseEvent<HTMLElement>,
        id: number,
    ) => void;
    onCommentPreviewClick: (e: React.MouseEvent<HTMLElement>) => void;
    openCommentPreviewOwnerAvatarModal: (
        e: React.MouseEvent<HTMLElement>,
    ) => void;
    post: PostType;
    createReactOnPreviewComment?: (
        commentId: string,
        postId: number,
    ) => (reactionTypeName: string, action: string) => void;
    handleCommentPreviewOptionsClicked?: (comment: CommentType) => void;
    handleCommentPreviewReportClicked?: (comment: CommentType) => void;
    showCommentTeaser?: boolean;
}) {
    const { postData, latestComment, id: postId } = post;

    const { funFacts: funFactsList } = useFunFactsStore();
    const funFacts = funFactsList?.[postId];

    return (
        <>
            {(latestComment || showCommentTeaser || !!funFacts?.length) && (
                <PostCardContentDivider />
            )}
            <FunFactsSection funFacts={funFacts} />
            {latestComment && (
                <CommentPreview
                    id={latestComment.id}
                    text={latestComment.content}
                    date={latestComment.createdAt}
                    updatedAt={latestComment.updatedAt}
                    user={latestComment.createdBy}
                    postId={postId}
                    handleCommentPreviewOptionsClicked={
                        handleCommentPreviewOptionsClicked
                    }
                    handleCommentPreviewReportClicked={
                        handleCommentPreviewReportClicked
                    }
                    handleOnCommentPreviewClicked={onCommentPreviewClick}
                    linkoutUrl={latestComment.linkoutUrl}
                    commentReactions={latestComment.commentReactions}
                    createReactOnPreviewComment={createReactOnPreviewComment}
                    openCommentPreviewOwnerAvatarModal={
                        openCommentPreviewOwnerAvatarModal
                    }
                    images={latestComment.images}
                    isEditorial={latestComment.isEditorial}
                />
            )}
            {showCommentTeaser && (
                <CommentCreationTeaser
                    onClick={(e) => {
                        onCommentButtonClick(e, postId);
                    }}
                />
            )}
            {postData.commentsCount > 1 && (
                <PostPreviewSectionFooterText onClick={onCommentPreviewClick}>
                    {`alle ${postData.commentsCount.toLocaleString(
                        "de-DE",
                    )} Kommentare ansehen`}
                </PostPreviewSectionFooterText>
            )}
        </>
    );
}

function CommentCreationTeaser({
    onClick,
}: {
    onClick: (e: React.MouseEvent<HTMLParagraphElement>) => void;
}) {
    const { uuid, gender, avatar } = useUserProfile();
    const showProfilePicture = true;
    const avatarOptions: AvatarOptions = {
        uuid: uuid ?? null,
        avatar: showProfilePicture ? avatar : undefined,
        gender,
        fallbackColor: !uuid ? "#596E38" : undefined,
        onError: () => userAvatarChecker(avatar, uuid),
        component: CommentAvatar,
    };

    return (
        <CreateCommentTeaserContainer onClick={onClick}>
            {UserAvatarFactory(avatarOptions)}
            <CreateCommentTeaserTextBox>
                Kommentieren...
            </CreateCommentTeaserTextBox>
        </CreateCommentTeaserContainer>
    );
}
